// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"B1-z","displaySixCardTiles":"C1-z"};